import React, { useEffect } from "react";
import image from "../images/about.jpg";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div>
      <section className="section about" id="about">
        <div className="section-center about-center">
          <article className="about-img" data-aos="fade-in">
            <img src={image} alt="" className="hero-photo" data-aos="fade-in" />
          </article>
          <article className="about-info" data-aos="fade-in">
            <div className="section-title about-title">
              <h2>About</h2>
              <div className="underline"></div>
            </div>
            <p data-aos="fade-in">
              Hello, I am Junaid Ahmad and I enjoy building and fixing things.
            </p>

            <p data-aos="fade-in">
              I Developed a full-stack web application, using React that allows
              users to explore various aspects of meditation. User's progress is
              stored on a backend created using Node and MongoDB."
            </p>

            <p data-aos="fade-in">
              "I Developed a language learning app, and a linked list data
              structure. React was used to create the front end components while
              Node and Mongo were used to create a backend that stores user
              data."
            </p>

            <Link to="/about">
              <motion.button
                className="about-btn btn"
                whileHover={{
                  scale: 1,
                  boxShadow: "0px 0px 15px #ca9c9c",
                  textShadow: "0px 0px 15px #b83455",
                }}
                whileTap={{ scale: 0.9 }}
                style={{ backgroundColor: "goldenrod" }}
              >
                About Me
              </motion.button>
            </Link>
          </article>
        </div>
      </section>
    </div>
  );
};

export default About;
